"use strict";

;

(function () {
  var mobileMenuToggle = document.querySelector('.toggle-menu');
  var mobileToggleSearch = document.querySelector('#mobile-search');
  var mobileSearchWrapper = document.querySelector('.mobile-search');
  var menuHeaders = document.querySelectorAll('.sub-menu__header > a');
  menuHeaders = [].slice.call(menuHeaders); // Remove anchor from submenu headers

  menuHeaders.forEach(function (menu) {
    menu.href = 'javascript:void(0);';
  });
  mobileMenuToggle.addEventListener('click', function (event) {
    event.preventDefault();
    document.body.classList.toggle('mobile-nav-open');
    ga_track('mobile navigation', 'click', 'toggle');

    if (mobileSearchWrapper.classList.contains('is-open')) {
      mobileToggleSearch.classList.remove('is-open');
      mobileSearchWrapper.classList.remove('is-open');
    }
  });
  var hasSubmenu = document.querySelectorAll('.nav-mobile > li.menu-item-has-children');

  var _loop = function _loop(i) {
    var anchor = hasSubmenu[i].querySelector('a');
    var submenu = hasSubmenu[i].querySelector('.sub-menu');
    var backLink = document.createElement('li');
    var overviewLink = document.createElement('li');
    var overviewURL = hasSubmenu[i].querySelector('a').getAttribute('href');
    overviewLink.innerHTML = "<a href=\"".concat(overviewURL, "\">Overview</a>");
    backLink.setAttribute('id', 'mobile-menu-back');
    backLink.innerHTML = "<a href=\"#\"><span class=\"icon-arrow-up\" aria-hidden=\"true\"></span> ".concat(hasSubmenu[i].querySelector('a').textContent, "</a>");
    submenu.insertBefore(backLink, submenu.childNodes[0]);
    submenu.insertBefore(overviewLink, submenu.childNodes[1]);
    var back = hasSubmenu[i].querySelector('#mobile-menu-back');
    anchor.addEventListener('click', function (event) {
      event.preventDefault();
      hasSubmenu[i].classList.add('is-active');
      document.body.classList.add('submenu-is-active');
    });
    back.addEventListener('click', function (event) {
      event.preventDefault();
      document.body.classList.remove('submenu-is-active');
      back.parentNode.parentNode.classList.remove('is-active');
    });
  };

  for (var i = 0; i < hasSubmenu.length; i += 1) {
    _loop(i);
  }
})();